import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FieldConfig } from '../../models/form-field.model';
import { FormConfigInstance } from '../../services/form.service';

export type InputType = 'color' | 'date' | 'datetime-local' |
  'email' | 'file' | 'hidden' | 'image' | 'month' | 'number' | 'password' | 'range' | 'reset' |
  'search' | 'tel' | 'text' | 'time' | 'url' | 'week' | 'textarea' | 'amount' | 'value';

export interface InputDateMask {
  timezone?: string;
  format: string;
}

export interface InputMask {
  mask: string;
  patterns?: any;
  showMaskTyped?: boolean;
}
export class FormInputField<N> extends FieldConfig<N> {

  inputType?: InputType;
  placeholder?: string;
  containerStyles?: any;
  inputStyles?: any;
  inputClasses?: string[];
  autoComplete?: string;
  value?: string | Observable<string> | BehaviorSubject<string> | Subject<string>;
  prefix?: {
    label?: string,
    icon?: string,
    action?: (service: FormConfigInstance) => void
  };
  suffix?: {
    label?: string,
    icon?: string,
    action?: (service: FormConfigInstance) => void
  }
  autosize?: {
    enable: boolean;
    minRows: number;
    maxRows: number;
  };
  options?:{
    min?: number,
    max?: number,
    step?: number
  }
  date?: InputDateMask;
  mask?: InputMask;

  constructor(o: FormInputField<N>) {
    super(o);
    this.type = 'input';
    this.autoComplete = o.autoComplete || 'off';
    if (!this.inputType) {
      this.inputType = 'text';
    }
    if (!this.autosize) {
      this.autosize = {
        enable: true,
        minRows: 1,
        maxRows: 5
      };
    }
  }


}
